import React, { useState } from 'react'
import { FontAwesome } from '../data/FontAwesome';
import AlarmForm from './AlarmForm';
import NaflAlarmForm from './NaflAlarmForm';
import AlarmList from './AlarmList';

export default function Alarms() {
    const [activeTab, setActiveTab] = useState('alarm')
    const tabClass = (tab) => 'nav-link btn-sm rounded-0 rounded-top' + (activeTab === tab ? ' active' : '')

    return (

        <div className='subMenu'>
            <div className='mb-3'>
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className={tabClass('alarm')} type="button" onClick={() => setActiveTab('alarm')}>
                            {FontAwesome.Plus} Alarm
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className={tabClass('nafl')} type="button" onClick={() => setActiveTab('nafl')}>
                            {FontAwesome.Plus} Nafl Prayer Alarm
                        </button>
                    </li>
                </ul>
                <div className="tab-content bg-primary rounded-bottom rounded-end px-2 py-3" id="pills-tabContent">
                    {activeTab === 'alarm' ? (<div>
                        <AlarmForm />
                    </div>) : null}
                    {activeTab === 'nafl' ? (<div>
                        <NaflAlarmForm />
                    </div>) : null}
                </div>
            </div>


            <AlarmList />


        </div>

    )
}
